import {useEffect, useState} from 'react';
import {useParams, useLocation} from 'react-router-dom';
import {Alert, Col, Empty, Row, Spin, Typography} from 'antd';
import {StudentsService} from './StudentsService';

const studentsService = new StudentsService();

export const StudentSessionDetails = () => {
  const [student, setStudent] = useState<any>(undefined);
  const [isError, setIsError] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const params: {studentId: string} = useParams();
  const {Title, Text} = Typography;
  const location = useLocation();

  useEffect(() => {
    studentsService
      .getSessionsStudentById(params.studentId)
      .then(resp => {
        setIsLoading(false);
        setStudent(resp);
      })
      .catch(() => {
        setIsLoading(false);
        setIsError(true);
      });
  }, [location.pathname]);

  return (
    <div style={{padding: 10}}>
      <Title style={{textAlign: 'center'}}>Student Sessions</Title>

      {!isError && !isLoading && (
        <>
          <Row>
            <Col span={12}>
              <div style={{margin: 20}}>
                <Text style={{display: 'block'}} strong={true}>
                  Student Name
                </Text>
                <Text>{student?.name ?? '-'}</Text>
              </div>
            </Col>
            <Col span={12}>
              <div style={{margin: 20}}>
                <Text style={{display: 'block'}} strong={true}>
                  Student ID
                </Text>
                <Text>{student?.id ?? '-'}</Text>
              </div>
            </Col>
          </Row>

          <Alert
            type="info"
            showIcon
            message="No sessions endpoint in the new user service"
            description="Student session details are not provided by the new user student endpoints yet."
            style={{margin: 20}}
          />

          <Empty description="No sessions available" />
        </>
      )}
      {isLoading && (
        <Spin size="large" style={{margin: 'auto', width: '100%'}} />
      )}
      {isError && <Title>Student fetching error</Title>}
    </div>
  );
};
